import React, { useEffect, useState } from "react";
import { Operacao } from "../../../Models/Cadastros/Operacao/Operacao";
import DropDownListComponent from "../../../Components/Forms/DropDownListComponent";
import TextFieldComponent from "../../../Components/Forms/TextFieldComponent";
import DropDownBooleanComponent from "../../../Components/Forms/DropDownBooleanComponent";
import InlineSearchComponent from "../../../Components/Forms/InlineSearchComponent";

const OperacaoDadosTab = (props: any) => {
    const [operacao, setOperacao] = useState<any>(new Operacao());
    const [perfis, setPerfis] = useState<any[]>([]);
    const [showPainelNaoConformidade, setShowPainelNaoConformidade] = useState(false);

    useEffect(() => {
        setPerfis(props.perfis);
    }, [props.perfis]);

    useEffect(() => {
        setOperacao(props.operacao);
    }, [props.operacao]);

    const optionBuscaPor = [
        {label: 'Transportador', value: '1' },
        {label: 'Remetente', value: '2' },
        {label: 'Origem', value: '3' },
        {label: 'Estado', value: '4' }
    ];

    return (
        <div className="row">
            <div className="col-md-3 mb-3">
                <DropDownBooleanComponent
                    label='Rota integração'
                    model={operacao}
                    modelField='habilitar_rota_integracao' />
            </div>

            <div className="col-md-3 mb-3">
                <TextFieldComponent
                    label="Limite Mínimo"
                    field='busca_valor_minimo'
                    model={operacao} />
            </div>

            <div className="col-md-3 mb-3">
                <TextFieldComponent
                    label="Senha integração"
                    field='senha_integracao'
                    model={operacao} />
            </div>

            <div className="col-md-3 mb-3">
                <TextFieldComponent
                    label="Tipo operação"
                    field='tipo_operacao'
                    model={operacao} />
            </div>

            <div className="col-md-3 mb-3">
                <TextFieldComponent
                    label="Norma"
                    field='tipo_operacao'
                    model={operacao} />
            </div>

            <div className="col-md-3 mb-3">
                <DropDownListComponent
                    label='Busca por'
                    options={optionBuscaPor}
                    valueField='value'
                    textField='label'
                    model={operacao}
                    modelField='busca_por_id' />
            </div>

            <div className="col-md-3 mb-3">
                <TextFieldComponent
                    label="Estados (ex: SP, RJ)"
                    field='busca_estados'
                    model={operacao} />
            </div>

            <div className="col-md-3 mb-3">
                {/* <DropDownBooleanComponent
                    label='Exceto estado'
                    model={operacao}
                    modelField='busca_nao_contem_estado_lista' /> */}
            </div>

            <div className="col-md-6 mb-6">
                <InlineSearchComponent
                    id='combo_empresa'
                    label='Transportador'
                    urlApi='buscaEmpresas'
                    valueField='id'
                    textField='cnpj_nome_unidade'
                    model={operacao}
                    modelField='busca_empresa_id' />
            </div>

            <div className="col-md-6 mb-6">
                <InlineSearchComponent
                    id='combo_empresa'
                    label='Remetente'
                    urlApi='buscaEmpresas'
                    valueField='id'
                    textField='cnpj_nome_unidade'
                    model={operacao}
                    modelField='busca_empresa_id' />
            </div>

            <div className="col-md-6 mb-6">
                <InlineSearchComponent
                    id='combo_empresa'
                    label='Origem'
                    urlApi='buscaEmpresas'
                    valueField='id'
                    textField='cnpj_nome_unidade'
                    model={operacao}
                    modelField='busca_empresa_id' />
            </div>

            <div className="col-md-6 mb-6">
                <InlineSearchComponent
                    id='combo_empresa'
                    label='Destino'
                    urlApi='buscaEmpresas'
                    valueField='id'
                    textField='cnpj_nome_unidade'
                    model={operacao}
                    modelField='busca_empresa_id' />
            </div>

            <div className="col-md-9 mb-9">
                <InlineSearchComponent
                    id='combo_empresa'
                    label='Empresa (remover)'
                    urlApi='buscaEmpresas'
                    valueField='id'
                    textField='cnpj_nome_unidade'
                    model={operacao}
                    modelField='busca_empresa_id' />
            </div>
            
            <div className="col-md-3 mb-3">
                {/* <DropDownBooleanComponent
                    label='Habilitado'
                    model={operacao}
                    modelField='habilitado' /> */}
            </div>
            

        </div>
    );
}

export default OperacaoDadosTab;